import { Checkbox } from "@mui/material";
import { OrderUi } from "../../../types/OrderListUi.ts";
import { useAppDispatch, useAppSelector } from "../../../../../state/state.tsx";
import {
    setFieldsForMarkOrderPaidModal,
    setFieldsForMMEditOrderModal,
    setFieldsForOrderSummaryModal,
    setFieldsForRemindPaymentWhatsappModal
} from "../../../../../state/ArbitrarySlice/ArbitratySlice.ts";
import { openModal } from "../../../../../state/ModalSlice/ModalSlice.ts";
import { SubscriptionType } from "../../../../../enums.ts";
import { selectEffectiveUID } from "../../../../../state/UserStatesV2/userSliceV2.ts";
import { copyToClipboard } from "../../../../Common/utilityFunctions.ts";
import { toast } from "react-toastify";

export default function LiveSubOrdersRenderer({ OrderData }: { OrderData: OrderUi }) {

    const Dispatch = useAppDispatch();
    const serviceProviderID = useAppSelector(selectEffectiveUID);

    function onClickMarkPaid(orderId: string) {
        Dispatch(setFieldsForMarkOrderPaidModal({ orderId: orderId, subscriptionId: OrderData.subscriptionId }));
        Dispatch(openModal("OrderMarkPaidConfirmModalOpen"));
    }

    function onClickWhatsappReminder(e: any) {
        e.stopPropagation();

        Dispatch(openModal("RemindPaymentWhatsappModalOpen"))
        Dispatch(setFieldsForRemindPaymentWhatsappModal({
            consumerName: OrderData.consumerName,
            chargeable: OrderData.chargeable.toString(),
            subscriptionName: OrderData.subscriptionName,
            cycleName: OrderData.cycleName,
            studentName: OrderData.studentName,
            payment_link: OrderData.link,
            providerName: OrderData.providerName,
            consumerPhone: OrderData.consumerPhone,
            serviceProviderID: serviceProviderID,
            orderId: OrderData.id,
            secondaryMobile: OrderData.secondaryMobile,
            bQuickCollect: OrderData.bQuickCollect,
            quickCollectString: OrderData.quickCollectString,
            invoiceString: OrderData.invoiceString
        }))
    }

    function onClickOrderSummary(orderId: string) {

        if (OrderData.subscriptionType === SubscriptionType.Count || OrderData.subscriptionType === SubscriptionType.MultiMonth) {
            Dispatch(setFieldsForMMEditOrderModal({ orderId: orderId, subscriptionId: OrderData.subscriptionId }))
            Dispatch(openModal("MMEditOrderModalOpen"))
        } else {
            Dispatch(setFieldsForOrderSummaryModal(({ orderId: orderId })))
            Dispatch(openModal("OrderSummaryModalOpen"))
        }


    }

    const assignedPlan = OrderData.assignedPlans[OrderData.assignedPlanIndex]


    return (
        <div onClick={() => { onClickOrderSummary(OrderData.id) }}
            className={"border-[1px] border-gray-300 mt-2 shadow-md hover:bg-gray-100  bg-white cursor-pointer rounded-xl p-2   flex"}>

            <div className={"w-full h-full  border-solid border-cc_brand border-l-4 pl-3 flex flex-col"}>
                <div className={"flex items-center justify-between  w-full"}>
                    <div>
                        <span className={"font-semibold "}>
                            {OrderData.cycleName}
                        </span>
                    </div>
                    <span
                        className={`ml-4 mt-4 py-1 px-2.5 inline-flex items-center text-sm font-medium ${OrderData.paymentstatus !== "Paid"
                            ? "bg-cc_bg-error text-cc_error"
                            : OrderData.settlementStatus === "Expired" || OrderData.settlementStatus === "Failed"
                                ? "bg-[#C84369] text-white"
                                : "bg-cc_bg-success text-cc_success"
                            } rounded-lg`}>
                        {OrderData.paymentstatus !== "Paid"
                            ? OrderData.paymentstatus
                            : OrderData.settlementStatus === "Pending"
                                ? "Unsettled"
                                : OrderData.settlementStatus} Rs. {OrderData.chargeable}
                    </span>
                </div>
                {!OrderData.bQuickCollect ? <div className={"flex items-center"}>
                    <span className={"text-sm"}>
                        {OrderData.subscriptionType === SubscriptionType.Count ? `${assignedPlan?.count} Classes` : assignedPlan?.billingCycle ? assignedPlan?.billingCycle : "Monthly"}
                    </span>
                    {OrderData.items && OrderData.items.length > 0 && <span className={"text-sm"}> + {OrderData.items.length} Item(s)</span>}
                </div> : <div className={"flex items-center"}>
                    <span className={"text-sm"}>
                        Quick Collect
                    </span>
                </div>}
                <div className={"flex justify-between text items-center"}>
                    <div>
                        {OrderData.paymentstatus === "Paid" && OrderData.orderType === "cash" ? (
                            <p className={"text-cc_link text-sm font-medium"}>Cash</p>
                        ) : OrderData.orderType === "writeoff" ? (
                            <p className={"text-cc_error text-sm font-medium"}>Cancelled</p>
                        ) : (
                            <p className={"text-cc_link underline-offset-2 underline text-sm font-medium cursor-pointer"}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    copyToClipboard(OrderData.link);
                                    toast.success("Payment link copied to clipboard");
                                }}>Payment Link</p>
                        )}
                    </div>

                    <div className={"flex items-center gap-8"}>
                        {(OrderData.paymentstatus === "Pending" || OrderData.paymentstatus === "Failed") && (
                            <div className={`relative ${OrderData.lastReminderTime ? "-top-0" : "top-0"}`}>
                                {OrderData.lastReminderTime && (
                                    <p className="text-xs text-gray-500 font-medium text-right mb-1">
                                        Last sent: {OrderData.lastReminderTime}
                                    </p>
                                )}
                                <div onClick={onClickWhatsappReminder} className="relative">
                                    <span
                                        className={`ml-4 py-1 px-3 inline-flex items-center text-sm bg-cc_brand text-white rounded-lg`}>
                                        Send Reminder
                                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none"
                                            style={{ padding: 0, marginLeft: 4 }}
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                d="M8.5 15.5C12.366 15.5 15.5 12.366 15.5 8.5C15.5 4.63401 12.366 1.5 8.5 1.5C4.63401 1.5 1.5 4.63401 1.5 8.5C1.5 9.75544 1.8305 10.9337 2.40924 11.9525L1.5 15.5L5.15743 14.6519C6.15069 15.1927 7.28946 15.5 8.5 15.5ZM8.5 14.4231C11.7712 14.4231 14.4231 11.7712 14.4231 8.5C14.4231 5.22878 11.7712 2.57692 8.5 2.57692C5.22878 2.57692 2.57692 5.22878 2.57692 8.5C2.57692 9.76303 2.97225 10.9337 3.64592 11.8951L3.11538 13.8846L5.13997 13.3785C6.09468 14.0373 7.25229 14.4231 8.5 14.4231Z"
                                                fill="#BFC8D0" />
                                            <path
                                                d="M14.5 8C14.5 11.3137 11.8137 14 8.5 14C7.23608 14 6.06344 13.6092 5.09633 12.9418L3.04545 13.4545L3.58288 11.4392C2.90046 10.4653 2.5 9.27944 2.5 8C2.5 4.68629 5.18629 2 8.5 2C11.8137 2 14.5 4.68629 14.5 8Z"
                                                fill="url(#paint0_linear_348_16324)" />
                                            <path fillRule="evenodd" clipRule="evenodd"
                                                d="M8.5 15C12.366 15 15.5 11.866 15.5 8C15.5 4.13401 12.366 1 8.5 1C4.63401 1 1.5 4.13401 1.5 8C1.5 9.25544 1.8305 10.4337 2.40924 11.4525L1.5 15L5.15743 14.1519C6.15069 14.6927 7.28946 15 8.5 15ZM8.5 13.9231C11.7712 13.9231 14.4231 11.2712 14.4231 8C14.4231 4.72878 11.7712 2.07692 8.5 2.07692C5.22878 2.07692 2.57692 4.72878 2.57692 8C2.57692 9.26303 2.97225 10.4337 3.64592 11.3951L3.11538 13.3846L5.13997 12.8785C6.09468 13.5373 7.25229 13.9231 8.5 13.9231Z"
                                                fill="white" />
                                            <path
                                                d="M6.75001 4.7497C6.58358 4.41541 6.32826 4.44501 6.07034 4.44501C5.60938 4.44501 4.89062 4.99715 4.89062 6.02473C4.89063 6.8669 5.26172 7.78877 6.51221 9.16781C7.71902 10.4987 9.30469 11.1872 10.6211 11.1637C11.9375 11.1403 12.2083 10.0075 12.2083 9.62492C12.2083 9.45535 12.1031 9.37075 12.0306 9.34777C11.582 9.13248 10.7547 8.73133 10.5664 8.65596C10.3782 8.58059 10.2799 8.68253 10.2188 8.73799C10.048 8.90068 9.70963 9.38015 9.59376 9.48799C9.47789 9.59583 9.30514 9.54125 9.23325 9.50048C8.96872 9.39433 8.25146 9.07529 7.67973 8.52107C6.97266 7.83564 6.93117 7.59983 6.79795 7.38991C6.69138 7.22198 6.76958 7.11894 6.8086 7.07392C6.96095 6.89814 7.1713 6.62675 7.26564 6.49189C7.35997 6.35702 7.28508 6.15226 7.24015 6.02473C7.04689 5.47626 6.88316 5.01713 6.75001 4.7497Z"
                                                fill="white" />
                                            <defs>
                                                <linearGradient id="paint0_linear_348_16324" x1="13.75" y1="3.5" x2="2.5"
                                                    y2="14"
                                                    gradientUnits="userSpaceOnUse">
                                                    <stop stopColor="#5BD066" />
                                                    <stop offset="1" stopColor="#27B43E" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </span>
                                    {(
                                        <div
                                            className="absolute -top-2 -right-2 h-5 w-5 flex items-center justify-center bg-red-500 text-white text-xs font-bold rounded-full border-2 border-white cursor-help"
                                            title={`Reminder sent ${OrderData.reminderCount} ${OrderData.reminderCount === 1 ? 'time' : 'times'}`}
                                        >
                                            {OrderData.reminderCount}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

                        <div className={"flex items-center"} onClick={(e) => e.stopPropagation()}>
                            <p className={"text-sm"}>{OrderData.paymentstatus === "Paid" ? "Paid" : "Mark Paid?"}</p>
                            <div><Checkbox onClick={(e) => { e.stopPropagation() }}
                                onChange={(e) => {
                                    e.stopPropagation()
                                    onClickMarkPaid(OrderData.id)
                                }}
                                size={"small"}
                                checked={OrderData.paymentstatus === "Paid"}
                                disabled={OrderData.paymentstatus === "Paid"}
                                inputProps={{ 'aria-label': 'controlled' }}
                            /></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}